import { Button } from "@wfp/ui"
import { useDownloadMarketListMutation } from "services/markets"
import { useDownloadCommodityListMutation } from "services/core/commodities"

interface Props {
  adm0Code: number | undefined
  hide?: string[]
}

export default function DownloadMarketButtons({ adm0Code, hide = [] }: Props) {
  const [downloadMarketList] = useDownloadMarketListMutation()
  const [downloadCommodityList] = useDownloadCommodityListMutation()

  return adm0Code ? (
    <div className="mt-1">
      {hide.length !== 2 && <p className="inline">Download market list:</p>}
      {!hide.includes("englishMarket") && (
        <Button small className="blue mr-1 ml-1" onClick={() => downloadMarketList({ adm0Code, localized: false })}>
          English
        </Button>
      )}
      {!hide.includes("localMarket") && (
        <Button small className=" blue mr-1" onClick={() => downloadMarketList({ adm0Code, localized: true })}>
          Localized
        </Button>
      )}
      {!hide.includes("commodityList") && (
        <Button small className="blue" onClick={() => downloadCommodityList({ adm0Code })}>
          Download commodity list
        </Button>
      )}
    </div>
  ) : null
}
